import { render, staticRenderFns } from "./StudentPage.vue?vue&type=template&id=132ee0ae"
import script from "./StudentPage.vue?vue&type=script&lang=js"
export * from "./StudentPage.vue?vue&type=script&lang=js"
import style0 from "./StudentPage.vue?vue&type=style&index=0&id=132ee0ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports